import { useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../../../hooks/useMediaQuery";
import DesktopLayout from "../../organisms/layouts/auth/DesktopLayout";
import MobileLayout from "../../organisms/layouts/auth/MobileLayout";

const AuthLayout = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const isSmallScreen = useMediaQuery("(min-width:1200px)");

  useEffect(() => {
    const urlCountry = searchParams.get("country")?.toUpperCase() || null;
    const storedLang = localStorage.getItem("i18nextLng");
    if (urlCountry && urlCountry.toLowerCase() !== "null") {
      localStorage.setItem("countryCode", urlCountry);
      i18n.changeLanguage(urlCountry?.toLowerCase() || "tr");
      return;
    }
    if (storedLang) {
      i18n.changeLanguage(storedLang || "tr");
      return;
    }
    localStorage.setItem("countryCode", "TR");
    i18n.changeLanguage("tr");
  }, [searchParams, i18n]);

  return isSmallScreen ? (
    <DesktopLayout>
      <Outlet />
    </DesktopLayout>
  ) : (
    <MobileLayout>
      <Outlet />
    </MobileLayout>
  );
};

export default AuthLayout;
